export default __webpack_public_path__ + "static/media/yomafleet_car_sales.199ff95b.png";